module.exports = __webpack_public_path__ + "assets/b7.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b7.png
// module id = 660
// module chunks = 0